export const actions = {
  URLS_LOAD_REQUESTED: 'URLS_LOAD_REQUESTED',
  URLS_LOAD_FILTERED_REQUESTED: 'URLS_LOAD_FILTERED_REQUESTED',
  URLS_LOAD_SUCCEEDED: 'URLS_LOAD_SUCCEEDED',
  URLS_LOAD_FILED: 'URLS_LOAD_FILED',

  URLS_BY_CARTEL_ID_LOAD_REQUESTED: 'URLS_BY_CARTEL_ID_LOAD_REQUESTED',
  URLS_BY_CARTEL_ID_LOAD_SUCCEEDED: 'URLS_BY_CARTEL_ID_LOAD_SUCCEEDED',
  URLS_BY_CARTEL_ID_LOAD_FILED: 'URLS_BY_CARTEL_ID_LOAD_FILED',

  URLS_BY_CARTEL_ID_REDUCED_LOAD_REQUESTED: 'URLS_BY_CARTEL_ID_REDUCED_LOAD_REQUESTED',
  URLS_BY_CARTEL_ID_REDUCED_LOAD_SUCCEEDED: 'URLS_BY_CARTEL_ID_REDUCED_LOAD_SUCCEEDED',
  URLS_BY_CARTEL_ID_REDUCED_LOAD_FILED: 'URLS_BY_CARTEL_ID_REDUCED_LOAD_FILED',

  URLS_LOAD_BY_CATEGORIA_REQUESTED: 'URLS_LOAD_BY_CATEGORIA_REQUESTED',
  URLS_LOAD_BY_CATEGORIA_SUCCEEDED: 'URLS_LOAD_BY_CATEGORIA_SUCCEEDED',
  URLS_LOAD_BY_CATEGORIA_FILED: 'URLS_LOAD_BY_CATEGORIA_FILED',

  URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_REQUESTED:
    'URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_REQUESTED',
  URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_SUCCEEDED:
    'URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_SUCCEEDED',
  URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_FILED: 'URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_FILED',

  URL_BYID_LOAD_REQUESTED: 'URL_BYID_LOAD_REQUESTED',
  URL_BYID_LOAD_SUCCEEDED: 'URL_BYID_LOAD_SUCCEEDED',
  URL_BYID_LOAD_FILED: 'URL_BYID_LOAD_FILED',

  URL_BYID_LOAD_INSERT_REQUESTED: 'URL_BYID_LOAD_INSERT_REQUESTED',

  URL_UPDATE_REQUESTED: 'URL_UPDATE_REQUESTED',
  URL_UPDATE_SUCCEEDED: 'URL_UPDATE_SUCCEEDED',
  URL_UPDATE_FILED: 'URL_UPDATE_FILED',

  URL_CARTEL_UPDATE_REQUESTED: 'URL_CARTEL_UPDATE_REQUESTED',
  URL_CARTEL_UPDATE_SUCCEEDED: 'URL_CARTEL_UPDATE_SUCCEEDED',
  URL_CARTEL_UPDATE_FILED: 'URL_CARTEL_UPDATE_FILED',

  URL_INSERT_REQUESTED: 'URL_INSERT_REQUESTED',
  URL_INSERT_SUCCEEDED: 'URL_INSERT_SUCCEEDED',
  URL_INSERT_FILED: 'URL_INSERT_FILED',

  URL_DELETE_REQUESTED: 'URL_DELETE_REQUESTED',
  URL_DELETE_SUCCEEDED: 'URL_DELETE_SUCCEEDED',
  URL_DELETE_FILED: 'URL_DELETE_FILED',

  URLS_DELETE_REQUESTED: 'URLS_DELETE_REQUESTED',
  URLS_DELETE_SUCCEEDED: 'URLS_DELETE_SUCCEEDED',
  URLS_DELETE_FILED: 'URLS_DELETE_FILED',

  URLS_BY_URL_GRUPO_ID_LOAD_REQUESTED: 'URLS_BY_URL_GRUPO_ID_LOAD_REQUESTED',
  URLS_BY_URL_GRUPO_ID_LOAD_SUCCEEDED: 'URLS_BY_URL_GRUPO_ID_LOAD_SUCCEEDED',
  URLS_BY_URL_GRUPO_ID_LOAD_FILED: 'URLS_BY_URL_GRUPO_ID_LOAD_FILED',

  URL_GRUPO_ASOCIACION_DELETE_REQUESTED: 'URL_GRUPO_ASOCIACION_DELETE_REQUESTED',
  URL_GRUPO_ASOCIACION_DELETE_SUCCEEDED: 'URL_GRUPO_ASOCIACION_DELETE_SUCCEEDED',
  URL_GRUPO_ASOCIACION_DELETE_FILED: 'URL_GRUPO_ASOCIACION_DELETE_FILED',

  URL_GRUPO_ASOCIACION_SORT_REQUESTED: 'URL_GRUPO_ASOCIACION_SORT_REQUESTED',
  URL_GRUPO_ASOCIACION_SORT_SUCCEEDED: 'URL_GRUPO_ASOCIACION_SORT_SUCCEEDED',
  URL_GRUPO_ASOCIACION_SORT_FILED: 'URL_GRUPO_ASOCIACION_SORT_FILED',

  URL_GRUPO_ASOCIACION_URL_REQUESTED: 'URL_GRUPO_ASOCIACION_URL_REQUESTED',
  URL_GRUPO_ASOCIACION_URL_SUCCEEDED: 'URL_GRUPO_ASOCIACION_URL_SUCCEEDED',
  URL_GRUPO_ASOCIACION_URL_FILED: 'URL_GRUPO_ASOCIACION_URL_FILED',

  CLEAR_URLS_GRUPOS_REQUESTED: 'CLEAR_URLS_GRUPOS_REQUESTED',

  URLS_ADICIONALES_LOAD_REQUESTED: 'URLS_ADICIONALES_LOAD_REQUESTED',
  URLS_ADICIONALES_LOAD_SUCCEEDED: 'URLS_ADICIONALES_LOAD_SUCCEEDED',
  URLS_ADICIONALES_LOAD_FILED: 'URLS_ADICIONALES_LOAD_FILED',

  URLS_ADICIONALES_UPDATE_REQUESTED: 'URLS_ADICIONALES_UPDATE_REQUESTED',
  URLS_ADICIONALES_UPDATE_SUCCEEDED: 'URLS_ADICIONALES_UPDATE_SUCCEEDED',
  URLS_ADICIONALES_UPDATE_FILED: 'URLS_ADICIONALES_UPDATE_FILED',

  URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_REQUESTED:
    'URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_REQUESTED',
  URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_SUCCEEDED:
    'URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_SUCCEEDED',
  URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_FILED:
    'URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_FILED',

  URLS_FOTOS_BY_URL_ID_LOAD_REQUESTED: 'URLS_FOTOS_BY_URL_ID_LOAD_REQUESTED',
  URLS_FOTOS_BY_URL_ID_LOAD_SUCCEEDED: 'URLS_FOTOS_BY_URL_ID_LOAD_SUCCEEDED',
  URLS_FOTOS_BY_URL_ID_LOAD_FILED: 'URLS_FOTOS_BY_URL_ID_LOAD_FILED',

  URLS_FOTOS_INSERT_REQUESTED: 'URLS_FOTOS_INSERT_REQUESTED',
  URLS_FOTOS_INSERT_SUCCEEDED: 'URLS_FOTOS_INSERT_SUCCEEDED',
  URLS_FOTOS_INSERT_FILED: 'URLS_FOTOS_INSERT_FILED',

  URLS_FOTOS_DELETE_REQUESTED: 'URLS_FOTOS_DELETE_REQUESTED',
  URLS_FOTOS_DELETE_SUCCEEDED: 'URLS_FOTOS_DELETE_SUCCEEDED',
  URLS_FOTOS_DELETE_FILED: 'URLS_FOTOS_DELETE_FILED',

  URL_FOTO_UPDATED: 'URL_FOTO_UPDATED',

  URLS_FOTOS_SORT_ITEMS_UPDATE_REQUESTED: 'URLS_FOTOS_SORT_ITEMS_UPDATE_REQUESTED',
  URLS_FOTOS_SORT_ITEMS_UPDATE_SUCCEEDED: 'URLS_FOTOS_SORT_ITEMS_UPDATE_SUCCEEDED',
  URLS_FOTOS_SORT_ITEMS_UPDATE_FILED: 'URLS_FOTOS_SORT_ITEMS_UPDATE_FILED',

  URLS_HISTORIAL_POSICIONES_REQUESTED: 'URLS_HISTORIAL_POSICIONES_REQUESTED',
  URLS_HISTORIAL_POSICIONES_SUCCEEDED: 'URLS_HISTORIAL_POSICIONES_SUCCEEDED',
  URLS_HISTORIAL_POSICIONES_FAILED: 'URLS_HISTORIAL_POSICIONES_FAILED',

  URL_SET_MOSTRARCANTIDAD_SUCEEDED: 'URL_SET_MOSTRARCANTIDAD_SUCEEDED',

  URL_RECUPERAR_URLS_REQUESTED: 'URLS_RECUPERAR_URLS_REQUESTED',
  URL_RECUPERAR_URLS_SUCCEEDED: 'URLS_RECUPERAR_URLS_SUCCEEDED',
  URL_RECUPERAR_URLS_FAILED: 'URLS_RECUPERAR_URLS_FAILED',

  URLS_DELETED_LOAD_SUCCEEDED: 'URLS_DELETED_LOAD_SUCCEEDED',
  URLS_DELETED_LOAD_REQUESTED: 'URLS_DELETED_LOAD_REQUESTED',
  URLS_DELETED_LOAD_FAILED: 'URLS_DELETED_LOAD_FAILED',
}

export const getUrlsFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.URLS_LOAD_FILTERED_REQUESTED,
    payload: filter,
  })
}

export const getUrlsByCartelIdAction = (dispatch, filter) => {
  dispatch({
    type: actions.URLS_BY_CARTEL_ID_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getUrlsByCartelIdReducedAction = (dispatch, filter) => {
  dispatch({
    type: actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getUrlsByUrlGrupoIdAction = (dispatch, urlGrupoId) => {
  dispatch({
    type: actions.URLS_BY_URL_GRUPO_ID_LOAD_REQUESTED,
    payload: urlGrupoId,
  })
}

export const clearUrlsGrupoAction = dispatch => {
  dispatch({
    type: actions.CLEAR_URLS_GRUPOS_REQUESTED,
  })
}

export const deleteUrlGrupoAsociacionAction = (dispatch, payload) => {
  dispatch({
    type: actions.URL_GRUPO_ASOCIACION_DELETE_REQUESTED,
    payload,
  })
}

export const onSubmitUrlGruposSortItemsUpdateAction = (dispatch, formUrlGrupoSort) => {
  dispatch({
    type: actions.URL_GRUPO_ASOCIACION_SORT_REQUESTED,
    payload: formUrlGrupoSort,
  })
}

export const onSubmitUrlGruposAsociarUpdateAction = (dispatch, formUrlGrupoAsociar) => {
  dispatch({
    type: actions.URL_GRUPO_ASOCIACION_URL_REQUESTED,
    payload: formUrlGrupoAsociar,
  })
}

export const getUrlsAction = dispatch => {
  dispatch({
    type: actions.URLS_LOAD_REQUESTED,
  })
}

// idiomaId es opcional: si se pasa, la API sólo devuelve las urls marcadas como
// visibles (Mostrar) en ese idioma.
export const getUrlsByCategoriaIdAction = (dispatch, categoriaId, idiomaId = null) => {
  dispatch({
    type: actions.URLS_LOAD_BY_CATEGORIA_REQUESTED,
    payload: { id: categoriaId, idiomaId },
  })
}

export const getUrlsByCategoriaWithUrlGrupoIdAction = (dispatch, categoriaId) => {
  dispatch({
    type: actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_REQUESTED,
    payload: categoriaId,
  })
}

export const getUrlCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.URL_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.URL_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertUrlFormAction = (dispatch, formUrl) => {
  dispatch({
    type: actions.URL_INSERT_REQUESTED,
    payload: formUrl,
  })
}

export const onSubmitUpdateUrlFormAction = (dispatch, formUrl) => {
  dispatch({
    type: actions.URL_UPDATE_REQUESTED,
    payload: formUrl,
  })
}

export const onSubmitUpdateUrlCartelFormAction = (dispatch, urlsCartelForm) => {
  dispatch({
    type: actions.URL_CARTEL_UPDATE_REQUESTED,
    payload: urlsCartelForm,
  })
}

export const deleteUrlAction = (dispatch, id) => {
  dispatch({
    type: actions.URL_DELETE_REQUESTED,
    payload: id,
  })
}

export const deleteListUrlAction = (dispatch, ids) => {
  dispatch({
    type: actions.URLS_DELETE_REQUESTED,
    payload: ids,
  })
}

export const getUrlsAdicionalesByUrlId = (dispatch, urlId) => {
  dispatch({
    type: actions.URLS_ADICIONALES_LOAD_REQUESTED,
    payload: urlId,
  })
}

export const onSubmitUrlsAdicionalesUpdateFormAction = (dispatch, urlsAdicionalesForm) => {
  dispatch({
    type: actions.URLS_ADICIONALES_UPDATE_REQUESTED,
    payload: urlsAdicionalesForm,
  })
}

export const getUrlsImagenesRelacionadasByUrlId = (dispatch, urlId) => {
  dispatch({
    type: actions.URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_REQUESTED,
    payload: urlId,
  })
}

export const onSubmitUrlsImagenesRelacionadasInsertFormAction = (
  dispatch,
  urlsImagenesrelacionadasForm,
) => {
  dispatch({
    type: actions.URLS_IMAGENES_RELACIONADAS_INSERT_REQUESTED,
    payload: urlsImagenesrelacionadasForm,
  })
}

export const deleteUrlImagenesRelacionadaAction = (dispatch, id) => {
  dispatch({
    type: actions.URLS_IMAGENES_RELACIONADAS_DELETE_REQUESTED,
    payload: id,
  })
}

export const getUrlsFotosByUrlId = (dispatch, urlId) => {
  dispatch({
    type: actions.URLS_FOTOS_BY_URL_ID_LOAD_REQUESTED,
    payload: urlId,
  })
}

export const onSubmitUrlsFotosInsertFormAction = (dispatch, urlsFotosForm) => {
  dispatch({
    type: actions.URLS_FOTOS_INSERT_REQUESTED,
    payload: urlsFotosForm,
  })
}

export const onUrlFotoUpdatedAction = (dispatch, urlId) => {
  dispatch({
    type: actions.URL_FOTO_UPDATED,
    payload: urlId,
  })
}

export const deleteUrlFotoAction = (dispatch, id) => {
  dispatch({
    type: actions.URLS_FOTOS_DELETE_REQUESTED,
    payload: id,
  })
}

export const onSubmitUrlsFotosSortItemsUpdateAction = (dispatch, formFotos) => {
  dispatch({
    type: actions.URLS_FOTOS_SORT_ITEMS_UPDATE_REQUESTED,
    payload: formFotos,
  })
}

export const getHistorialPosicionesAction = (dispatch, idCategoria) => {
  dispatch({
    type: actions.URLS_HISTORIAL_POSICIONES_REQUESTED,
    payload: idCategoria,
  })
}

export const setUrlMostrarCantidadAction = (dispatch, payload) => {
  dispatch({
    type: actions.URL_SET_MOSTRARCANTIDAD_SUCEEDED,
    payload,
  })
}

export const recuperarUrlsAction = (dispatch, ids) => {
  dispatch({
    type: actions.URL_RECUPERAR_URLS_REQUESTED,
    payload: ids,
  })
}

export const getUrlsDeletedAction = dispatch => {
  dispatch({
    type: actions.URLS_DELETED_LOAD_REQUESTED,
  })
}
